var _rect, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgListingViewImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    width: 22,
    height: 22,
    rx: 4,
    fill: "#2795AE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9061 10.5945C17.8026 10.4478 15.3251 7 11 7C6.67486 7 4.19743 10.4478 4.09394 10.5945C3.96869 10.7726 3.96869 11.0055 4.09394 11.1834C4.19743 11.33 6.67486 14.7779 11 14.7779C15.3251 14.7779 17.8026 11.33 17.9061 11.1835C18.0313 11.0055 18.0313 10.7725 17.9061 10.5945ZM11 13.7238C7.96229 13.7238 5.91133 11.6668 5.24413 10.8881C5.90913 10.1082 7.95071 8.05417 11 8.05417C14.0377 8.05417 16.0887 10.1111 16.7557 10.8899C16.0907 11.6697 14.0493 13.7238 11 13.7238Z",
    fill: "#2795AE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9984 8.42578C10.4368 8.42578 9.90197 8.59695 9.45152 8.92045C8.31691 9.73651 8.08789 11.284 8.9414 12.3693C9.43264 12.9938 10.1838 13.3519 11.0016 13.3519C11.5632 13.3519 12.0979 13.181 12.5479 12.8575C13.0976 12.4622 13.4535 11.8857 13.55 11.2344C13.6463 10.5827 13.4719 9.93443 13.0583 9.40853C12.5675 8.78394 11.8166 8.42578 10.9984 8.42578ZM12.7316 11.1234C12.6659 11.5656 12.4245 11.957 12.051 12.2254C11.7455 12.4452 11.3827 12.5613 11.0019 12.5613C10.4461 12.5613 9.93615 12.3179 9.60254 11.8941C9.02297 11.157 9.17841 10.1065 9.94896 9.55243C10.2546 9.33276 10.6177 9.21641 10.9987 9.21641C11.5546 9.21641 12.0644 9.45979 12.3977 9.88357C12.6784 10.2407 12.7971 10.6811 12.7316 11.1234Z",
    fill: "#2795AE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5878 9.80127C11.4431 9.80127 11.3012 9.85793 11.1978 9.95544C11.0961 10.0543 11.0366 10.19 11.0366 10.3284C11.0366 10.4667 11.0961 10.6038 11.1978 10.7013C11.2998 10.7988 11.4431 10.8553 11.5878 10.8553C11.7325 10.8553 11.8744 10.7988 11.9778 10.7013C12.0797 10.6038 12.139 10.4667 12.139 10.3284C12.139 10.19 12.0797 10.0543 11.9778 9.95544C11.8746 9.8578 11.7325 9.80127 11.5878 9.80127Z",
    fill: "#2795AE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListingViewImage);
export default __webpack_public_path__ + "static/media/listing-view-image.d83f68ebc6153b80514e39e8efe759eb.svg";
export { ForwardRef as ReactComponent };